// ==========================
// Centralized Material Web Imports
// ==========================
//import { MDCLayoutGrid } from '@material/layout-grid';

import '@material/web/tabs/tabs.js';
import '@material/web/dialog/dialog.js';
import '@material/web/switch/switch.js';
import '@material/web/textfield/outlined-text-field.js';
import '@material/web/textfield/filled-text-field.js';
import '@material/web/select/outlined-select.js';
import '@material/web/select/select-option.js';
import '@material/web/select/filled-select.js';
import '@material/web/button/filled-button.js';
import '@material/web/button/outlined-button.js';
import '@material/web/button/text-button.js';
import '@material/web/tabs/primary-tab.js';
import '@material/web/tabs/secondary-tab.js';
import '@material/web/tabs/tabs.js';
import '@material/web/checkbox/checkbox.js';
import '@material/web/radio/radio.js';
import '@material/web/divider/divider.js';
import '@material/web/icon/icon.js';
import '@material/web/list/list.js';
import '@material/web/list/list-item.js';
import '@material/web/iconbutton/icon-button.js';
import '@material/web/menu/menu.js';
import { MDCMenu } from '@material/menu';
import { MDCMenuSurface } from '@material/menu-surface';

// ==========================
// Existing Imports
// ==========================
import { FarmhandMcw } from './farmhand-mcw';
import { IncNavigation } from './navigation';
import { TabPager } from './tab-pager';
import { MembershipCard } from './components/membership-card';
import jQuery from 'jquery';

declare var window: any;

// ==========================
// jQuery Setup
// ==========================
window.$ = window.jQuery = jQuery;
import 'script-loader!../../../node_modules/jquery/dist/jquery.min.js';
import { TabPane } from './tab-pane';
import { MegaTab } from './mega-tab';
import { PaperlessPreference } from './components/paperless-preference';
import { PublicationsManager } from './components/publications-manager';
import { SubscriptionCenter } from './components/subscription-center';
import { DemographicsEditor } from './components/demographics-editor';
import { ForgotPassword } from './components/forgot-password';
import { Collapsible } from './components/collapsible';

// ==========================
// Utility Imports
// ==========================
import { bindComponentsToClass } from './utils/bind-components-to-class';
import { loopThroughElements } from './utils/loop-through-elements';
import { onReady } from './utils/on-ready';

// ==========================
// Legacy Scripts (Global Scope)
// ==========================
import 'script-loader!./knockout-validation.min.js';

// ==========================
// IE Polyfills
// ==========================
import 'whatwg-fetch';
import 'es6-promise/auto';
import 'polyfill-array-includes';
import { LoginStatus } from './utils/login-status';

// ==========================
// Instantiate Global Objects
// ==========================
window.farmhandMcw = new FarmhandMcw();
window.TabPager = new TabPager();

// ==========================
// Initialize on DOM Ready
// ==========================
onReady(() => {
    window.nav = bindComponentsToClass(
        IncNavigation.cssClass,
        el => new IncNavigation(el as HTMLDivElement)
    );
    window.tabPanes = bindComponentsToClass(TabPane.cssClass, el => new TabPane(el));
    window.megaTabs = bindComponentsToClass(MegaTab.cssClass, el => new MegaTab(el));
    window.membershipCards = bindComponentsToClass(MembershipCard.cssClass, el => new MembershipCard(el));
    window.paperlessPreferenceManagers = bindComponentsToClass(PaperlessPreference.cssClass, el => new PaperlessPreference(el));
    window.publicationManager = bindComponentsToClass(PublicationsManager.cssClass, el => new PublicationsManager(el));
    window.subscriptionCenter = bindComponentsToClass(SubscriptionCenter.cssClass, el => new SubscriptionCenter(el));
    window.demographicsEditors = bindComponentsToClass(DemographicsEditor.cssClass, el => new DemographicsEditor(el));

    const forgotPasswordElement = document.getElementById(ForgotPassword.id);
    if (forgotPasswordElement)
        window.forgotPassword = new ForgotPassword(forgotPasswordElement);

    window.collapse = new Collapsible();

    const loginStatusElement = document.getElementById(LoginStatus.id);
    if (loginStatusElement)
        window.lis = new LoginStatus(loginStatusElement);

    const mobileLoginStatusElement = document.getElementById('navigation-mobile-menu-ctx');
    if (mobileLoginStatusElement)
        window.mobileLis = new LoginStatus(mobileLoginStatusElement);

});

